export class InitEvent
{
    public readonly designName:string;
    public readonly uuid:string;
    public readonly currentDesign:any;
    public readonly currentVersion:any;
    public readonly lastSyncValueEventsBySlotId:any;

    constructor(json:any)
    {
        this.designName = json['designName'];
        this.uuid = json['uuid'];
        this.currentDesign = json['currentDesign'];
        this.currentVersion = json['currentVersion'];
        this.lastSyncValueEventsBySlotId = json['lastSyncValueEventsBySlotId'];
    }
}
